import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GlobalComponent from "./context/global-states";
import { Provider } from "react-redux";
import Store from "./redux/store/Store";
import { API_BASE_URL } from "./environment";
import { LogProvider } from "./context/LogContext";
import ColorPicker from "./Componant/ColorPicker";
// import Customization from "./Componant/Widget/Customization";

import "bootstrap-icons/font/bootstrap-icons.css";
console.log(".env.development=", process.env);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={Store}>
    <LogProvider>
      <GlobalComponent>
        <BrowserRouter basename="/knowledgerepo">
          {/* <ColorPicker /> */}
          <App />
          {/* <Customization /> */}
          <ToastContainer />
        </BrowserRouter>
      </GlobalComponent>
    </LogProvider>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
